import { prefixes, prependIntlIds } from "../utils";

export const unprefixedToastMessages = {
  preventedSubmit:
    "Před uložením je třeba vyřešit kritické validační chyby (tučně)",

  "alertText.missing_detail":
    "Při zapnuté editaci nebo vytváření a editaci musí mít přiřazený detail",

  "alertText.duplicateSelectNames":
    "některá z prezentačních položek šablony má možnosti výběru se stejným textem",

  "alertText.missingHegClassId": "Vyberte HeG třídu",

  "alertText.missingHegFolderId": "Vyberte HeG pořadač",

  "alertText.missingItemColumnAlias":
    "Vyberte spojovací sloupec položkové šablony",

  "alertText.overviewHasNoMobileLayout":
    "Pokud u šablony nenastavíte rozložení mobilních buněk, nebude možné ji zobrazit na mobilu",

  "alertText.detailHasNoMobileLayout":
    "U detailu je nutné nastavit rozložení buněk",

  "alertText.emptySortOrder":
    "Jedna z položek má nastaven typ řazení, ale nemá nastaveno pořadí řazení",

  "alertText.duplicateSelectValues":
    "některá z prezentačních položek šablony má možnosti výběru se stejnou hodnotou",

  "alertText.missingHegFileRelation":
    "Jedna z položek má typ Heg File, ale nemá přiřazenou propojovací šablonu",

  "alertText.missingColumn":
    "Jedna z položek nemá nastavený propojovací sloupec",

  "alertText.missingDisplayColumn":
    "Jedna z položek nemá nastavený zobrazovací sloupec",

  "alertText.importantKpiThresholdExceedsCritical":
    "Hranice pro důležitou úroveň KPI nesmí převýšit hranici kritické úrovně",

  "alertText.itemLinkColumnNotRepresentedInDataModel":
    "Jeden ze spojovacích sloupců položkové šablony není přítomný jako sloupec v datovém modelu. Je nutné ho přidat (třeba jako schovaný)",

  "alertText.missingOverviewTemplate":
    "Dokud nenavážete přehledovou šablonu, nebudou generovány notifikace uživatelům",

  "alertText.missingTitleAtribute":
    "Není nastaven titulek na žádném z atributů",
};

export default prependIntlIds(
  prefixes.tBuilderValidation,
  unprefixedToastMessages
);
